import { DialogWithForm } from '@strata/react-dialog';
import { SuccessToast } from '@strata/react-toast-message';
import { Formik } from 'formik';
import PropTypes from 'prop-types';

import { BulkChangeWarningMessage } from 'components/upcomingTreatments/dialogs/BulkChangeWarningMessage';
import {
    useRunRouteSimulatorMutation,
    useSimulateSingleTreatmentMutation,
} from 'store/api/goLiveApi';

const Title = 'Run route simulator';

export const RunRouteSimulatorDialog = ({
    isOpen,
    onClose,
    treatmentsCount = 1,
    apiQueryParams = undefined,
}) => {
    const [runRouteSimulator] = useRunRouteSimulatorMutation();
    const [simulateSingleTreatment] = useSimulateSingleTreatmentMutation();

    return (
        <Formik
            initialValues={{}}
            enableReinitialize
            onSubmit={async () => {
                if (apiQueryParams?.treatmentId) {
                    await simulateSingleTreatment({
                        treatmentId: apiQueryParams.treatmentId,
                    }).unwrap();
                    SuccessToast({ message: 'Route simulation completed.' });
                } else {
                    await runRouteSimulator(apiQueryParams).unwrap();
                    SuccessToast({ message: 'Route simulation successfully started.' });
                }
                onClose();
            }}
        >
            {(formik) => (
                <DialogWithForm
                    dialogTitle={Title}
                    isOpen={isOpen}
                    width={440}
                    secondaryButtonLabel="Cancel"
                    onSecondaryButtonClick={onClose}
                    primaryButtonLabel="Rerun Simulator"
                    isPrimaryButtonDisabled={!formik.isValid || formik.isSubmitting}
                    dialogContent={
                        <div className="flex__gap--large" style={{ flexDirection: 'column' }}>
                            <div>
                                Are you sure you want to run the route simulator? For large lists of
                                treatments, this may take up to an hour or more.
                            </div>
                            <BulkChangeWarningMessage
                                apiQueryParams={apiQueryParams}
                                treatmentsCount={treatmentsCount}
                            />
                        </div>
                    }
                />
            )}
        </Formik>
    );
};

RunRouteSimulatorDialog.Title = Title;

RunRouteSimulatorDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    treatmentsCount: PropTypes.number,
    apiQueryParams: PropTypes.shape({
        treatmentId: PropTypes.string,
        searchText: PropTypes.string,
        goLiveDate: PropTypes.arrayOf(PropTypes.string),
        productServiceOid: PropTypes.arrayOf(PropTypes.string),
        segmentId: PropTypes.arrayOf(PropTypes.string),
        incumbentSupplier: PropTypes.arrayOf(PropTypes.string),
        productType: PropTypes.arrayOf(PropTypes.string),
        isLDD: PropTypes.arrayOf(PropTypes.bool),
        hasIssues: PropTypes.arrayOf(PropTypes.string),
        releaseStatus: PropTypes.arrayOf(PropTypes.string),
        upcomingTreatmentBatchName: PropTypes.arrayOf(PropTypes.string),
        preferredPharmacyOffer: PropTypes.arrayOf(PropTypes.string),
        therapeuticCategory: PropTypes.arrayOf(PropTypes.string),
    }),
};
